import notaVersao from './notaVersaoRepository'

export default baseUrl => {
    return {
        notaVersao: notaVersao(baseUrl),
    }
}